<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">Financial Year</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button class="ui small button primary" (click)="addAffiliateType()">
        Add Financial Year
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>

  <div class="ui vertical basic segment" *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <!-- </div> -->
  <div
    fxLayout="row"
    appMargin
    class="ui segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    id="dark"
  >
    <div fxFlex="30%">Year</div>
    <div fxFlex="30%">Status</div>
    <div fxFlex="grow">Created By</div>
    <div fxFlex="10%"></div>
  </div>
  <div
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div appMargin marginB="3" appPadding paddingB="0">
      <div
        class="ui attached segment"
        *ngFor="let year of financial"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="30%" style="text-transform: capitalize">
          {{ year?.year }}
        </div>
        <div fxFlex="30%" style="text-transform: capitalize">
          {{ year?.status }}
        </div>
        <div fxFlex="grow">{{ year?.createdBy | createdBy }}</div>
        <div fxFlex="10%">
          <div class="ui mini basic primary dropdown" suiDropdown>
          <esl-button buttonType="primary" buttonSize="small" buttonState="outline" buttonActionState="default" [hasLine]="true" [hasSuffixIcon]="true" [buttonMenu]="'dropdownMenu'" [hasDropdown]="true" [isClickable]="true"></esl-button>
            <!-- <img src="assets/icons/Button.svg" alt="" /> -->
            <div class="left menu" suiDropdownMenu>
              <div
                class="item"
                (click)="publish(year.year)"
                *ngIf="year.status === 'UNPUBLISHED'"
              >
                Publish to Contractor
              </div>
              <div
                class="item"
                (click)="unPublish(year.year)"
                *ngIf="year.status === 'PUBLISHED'"
              >
                Unpublish from Contractors
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui icon small button">
          <i class="database icon"></i>
        </div>
        <a class="ui basic label">{{ totalItems }} Record(s)</a>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="small"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
